// extracted by mini-css-extract-plugin
export default {"SnackbarItem-variantSuccess":"eula_SnackbarItem-variantSuccess__Ms6Yc","SnackbarContainer-root":"eula_SnackbarContainer-root__FK+es","banner_sec":"eula_banner_sec__yYqts"};